import { useIntl } from "react-intl";

const AuditLogsForUserAcitivity = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.audit-logs-for-user-activity.title",
            defaultMessage: "Audit logs for user activity"
        }),
        body: intl.formatMessage({
            id: "jira-software-pricing.modal-content.audit-logs-for-user-activity.body",
            defaultMessage:
                "Comprehensive audit logging of user-initiated activity in Jira, including permission changes."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default AuditLogsForUserAcitivity;
